import React, { useState } from "react"

export default function AddToCalendarButton({
  title,
  startDate,
  endDate,
  startTime,
  endTime,
  timeZone,
  location,
  description,
  label = "Add to My Calendar",
  iCalFileName,
  linkToOrder,
  children,
  style
}) {
  const [open, setOpen] = useState(false)

  const handleICSDownload = () => {
    const formatICSDateTime = (date, time) => {
      // Converts YYYY-MM-DD and HH:MM to YYYYMMDDTHHMMSS
      return `${date.replace(/-/g, "")}T${time.replace(/:/g, "")}00`
    }

    const uid = `${Date.now()}` // Ensure uniqueness
    const dtstamp = formatICSDateTime(startDate, startTime)

    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${dtstamp}
SUMMARY:${title}
DESCRIPTION:${description}
LOCATION:${location}
URL:${linkToOrder}
DTSTART;TZID=${timeZone}:${formatICSDateTime(startDate, startTime)}
DTEND;TZID=${timeZone}:${formatICSDateTime(endDate, endTime)}
BEGIN:VALARM
TRIGGER:-PT1H
ACTION:DISPLAY
DESCRIPTION:Reminder: ${title}
END:VALARM
END:VEVENT
END:VCALENDAR
    `.trim()

    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = iCalFileName || "event.ics"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    setOpen(false)
  }

  const handleGoogleClick = () => {
    const formatDateTime = (date, time) => {
      return `${date.replace(/-/g, "")}T${time.replace(/:/g, "")}00Z`
    }

    const gcalUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      title
    )}&dates=${formatDateTime(startDate, startTime)}/${formatDateTime(
      endDate,
      endTime
    )}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(
      location
    )}&sf=true&output=xml`

    window.open(gcalUrl, "_blank")
    setOpen(false)
  }

  return (
    <div style={{ position: "relative", display: "inline-block", ...style }}>
      {children ? (
        <div onClick={() => setOpen(!open)}>{children}</div>
      ) : (
        <button className="add-to-calendar-btn">
          <span className="add-to-calendar-text">{label}</span>
          <span className={`caret-icon ${open ? "up" : "down"}`} />
        </button>
      )}

      {open && (
        <ul
          style={{
            position: "absolute",
            bottom: "100%",
            left: 0,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            listStyle: "none",
            padding: "8px 0",
            margin: 0,
            zIndex: 10,
            width: "auto",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
          }}
        >
          <li style={itemStyle} onClick={handleGoogleClick}>
            Google Calendar
          </li>
          <li style={itemStyle} onClick={handleICSDownload}>
            Apple Calendar
          </li>
          <li style={itemStyle} onClick={handleICSDownload}>
            Outlook
          </li>
          <li style={itemStyle} onClick={handleICSDownload}>
            Yahoo
          </li>
          <li style={itemStyle} onClick={handleICSDownload}>
            iCal
          </li>
        </ul>
      )}
    </div>
  )
}

const itemStyle = {
  padding: "8px 16px",
  cursor: "pointer",
  hover: {
    backgroundColor: "#eee"
  }
}
